import axios from 'axios';
import { endPoint1 } from './instace';

export const getPublicWebSubjects = async () => {
  try {
    const response = await axios.get(`${endPoint1}/api/public/web-subjects`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
